import { render, staticRenderFns } from "./UserExcuse.vue?vue&type=template&id=572b688a"
import script from "../../../scripts/partials/user/UserExcuse.js?vue&type=script&lang=js&external"
export * from "../../../scripts/partials/user/UserExcuse.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports